<template>
  <div>
    <h3 class="title is-3">
      <router-link to="/">
        <b-icon icon="chevron-left" size="is-small"></b-icon>
      </router-link>&nbsp;
      New Page
    </h3>
    <hr>
    <div class="columns">
      <div class="column">
        <!-- name -->
        <div class="field">
          <label class="label">Name</label>
          <div class="control">
            <input class="input" type="text" v-model="name">
          </div>
        </div>
        <!-- description -->
        <div class="field">
          <label class="label">Description</label>
          <div class="control">
            <input class="input" type="text" v-model="description">
          </div>
        </div>
        <!-- url -->
        <div class="field">
          <label class="label">Url</label>
          <div class="control">
            <input class="input" type="text" v-model="url">
          </div>
        </div>
      </div>
      <div class="column">
        <!-- enabled -->
        <div class="field">
          <label class="label">Enabled</label>
          <b-switch v-model="enabled" type="is-success"></b-switch>
        </div>
        <!-- visible -->
        <div class="field">
          <label class="label">Visible</label>
          <b-switch v-model="visible" type="is-success"></b-switch>
        </div>
        <!-- root -->
        <div class="field">
          <label class="label">Show on Root</label>
          <b-switch v-model="root" type="is-success"></b-switch>
        </div>
      </div>
    </div>
    <div class="field">
      <button class="button is-primary" @click="save">Save</button>
    </div>
  </div>
  <!-- <loading v-else></loading> -->
</template>

<script>
import loading from "@/components/Loading";
import { CREATE_PAGE } from "@/store/actions";

export default {
  name: "Page-New",
  data() {
    return {
      name: "",
      description: "",
      url: "",
      enabled: true,
      visible: true,
      root: true
    };
  },
  methods: {
    save() {
      const data = {
        name: this.name.trim(),
        description: this.description.trim(),
        url: this.url.trim(),
        enabled: this.enabled,
        visible: this.visible,
        root: this.root
      };

      this.$store.dispatch(CREATE_PAGE, data).then(res => {
        if (res && res.status === 204) {
          this.$success("Page created");
          this.$router.push('/pages');
        }
      });
    }
  }
};
</script>

